import { bunja } from 'bunja';
import { atom } from 'jotai';

import { ordersBunja } from '@flipster/r230522/original/order';
import { openPositionsBunja } from '@flipster/r230522/original/position';

import { tradeSymbolBunja } from '@web/app/[locale]/(web)/trade/_misc/symbol';

import { yourPositionsBunja } from '../state';
import { countBySymbolFilter } from './utils';

/**
 * 포지션 섹션 헤더의 데이터 레이어. 계산은 전부 여기서 하고 UI는 consume만 한다.
 * 카운트를 primitive number로 노출해, 소켓 tick마다 openPositions/pendingPositions가
 * 새 객체로 재구성되더라도 값이 같으면 Object.is dedup으로 헤더 리렌더를 차단한다.
 * (기존에는 {openCount, pendingCount} 객체 atom 구독 + openPositionsAtom 통짜 구독이라 매 tick 리렌더)
 */
export const positionSectionHeaderDataBunja = bunja(() => {
  const { symbol, symbolInfoAtom } = bunja.use(tradeSymbolBunja);
  const { openPositionsAtom } = bunja.use(openPositionsBunja);
  const { pendingPositionsAtom } = bunja.use(ordersBunja);
  const { showAllSymbolAtom } = bunja.use(yourPositionsBunja);

  // 탭 뱃지 카운트 (Show all 여부 반영)
  const displayOpenCountAtom = atom((get) =>
    countBySymbolFilter(get(openPositionsAtom), { symbol, showAllSymbol: get(showAllSymbolAtom) }),
  );
  const displayPendingCountAtom = atom((get) =>
    countBySymbolFilter(get(pendingPositionsAtom), { symbol, showAllSymbol: get(showAllSymbolAtom) }),
  );

  const canCloseAllPositionsAtom = atom((get) => get(displayOpenCountAtom) > 0);

  // Close all 라벨용 심볼 표기 (symbolInfo 객체 통구독 대신 문자열만 전파)
  const displayShortNameAtom = atom((get) => get(symbolInfoAtom)?.displayShortName);

  // Close all 대상 포지션. 매 tick 재계산되므로 구독하지 말고
  // 클릭 시점에 useAtomCallback으로 스냅샷만 읽는다 (source 그대로 — 주문 경로 안전).
  const closablePositionsAtom = atom((get) => {
    const openPositions = get(openPositionsAtom);
    const showAllSymbol = get(showAllSymbolAtom);
    return Object.values(openPositions ?? {})
      .flat()
      .filter((position) => showAllSymbol || position.symbol === symbol);
  });

  return {
    symbol,
    displayOpenCountAtom,
    displayPendingCountAtom,
    canCloseAllPositionsAtom,
    displayShortNameAtom,
    closablePositionsAtom,
  };
});
positionSectionHeaderDataBunja.debugLabel = 'positionSectionHeaderDataBunja';
